import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CUSTOMER_AUTH_EVENT, customerApi, getCustomerToken } from '../../api/client';
import { clearCart, hydrateCart, selectCartItems } from '../../Features/Cart/cartSlice';
import { GUEST_CART_STORAGE_KEY } from '../../utils/storageKeys';
import { removeStorageItem } from '../../utils/localStorageState';

export default function CustomerCartSync() {
  const dispatch = useDispatch();
  const items = useSelector(selectCartItems);
  const [authVersion, setAuthVersion] = useState(0);
  const ready = useRef(false);
  const saveTimer = useRef(null);
  const wasAuthenticated = useRef(Boolean(getCustomerToken()));

  useEffect(() => {
    const changed = () => setAuthVersion((version) => version + 1);
    const storageChanged = (event) => {
      if (event.key == null || event.key === 'customer_token') changed();
    };
    window.addEventListener(CUSTOMER_AUTH_EVENT, changed);
    window.addEventListener('storage', storageChanged);
    return () => {
      window.removeEventListener(CUSTOMER_AUTH_EVENT, changed);
      window.removeEventListener('storage', storageChanged);
    };
  }, []);

  useEffect(() => {
    let active = true;
    ready.current = false;
    clearTimeout(saveTimer.current);
    const authenticated = Boolean(getCustomerToken());
    if (!authenticated) {
      if (wasAuthenticated.current) dispatch(clearCart());
      wasAuthenticated.current = false;
      ready.current = false;
      return () => { active = false; };
    }
    wasAuthenticated.current = true;
    customerApi('/api/customer/cart')
      .then((data) => {
        if (!active) return;
        dispatch(hydrateCart(data.items));
        removeStorageItem(GUEST_CART_STORAGE_KEY);
        ready.current = true;
      })
      .catch(() => {});
    return () => { active = false; };
  }, [authVersion, dispatch]);

  useEffect(() => {
    if (!ready.current || !getCustomerToken()) return undefined;
    clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(() => {
      customerApi('/api/customer/cart', {
        method: 'PUT',
        body: JSON.stringify({ items }),
      }).catch(() => {});
    }, 400);
    return () => clearTimeout(saveTimer.current);
  }, [items]);

  return null;
}
